"use client";

import { ISearchStationItem } from "@/interfaces/Map";
import style from "./style.module.scss";

type Props = {
  station: ISearchStationItem;
  onSelect: (station: ISearchStationItem) => void;
};

const SearchStationItem = ({ station, onSelect }: Props) => {
  return (
    <button
      type="button"
      className={style.searchStationItem}
      onClick={() => onSelect(station)}
    >
      <span className={style.icaoBadge}>{station.icao_code}</span>
      <span className={style.stationName}>{station.name}</span>
    </button>
  );
};

export default SearchStationItem;

